export {
  PLUGIN_KEY,
  PLUGIN_PRIORITY,
  MultipleSelectionHandles,
} from './multipleSelectionHandles';
